/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconGPlus({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1.1953125em" height="1em" viewBox="0 0 306 256" className={className} {...props} {...attrs} data-test="IconGPlus">  <path fill="currentColor" d="M255 134v26h-22v-26h-25v-22h25V87h22v25h24v22h-24zm-61.3-21h-82v28h47.9c-7.1 35.7-55.3 48.2-81.1 24.9-26.5-20.4-25.3-65.3 2.3-84.3 19.3-15.3 46.7-11.5 66 1.7 7.6-7 14.7-14.4 21.5-22.2-16-12.7-35.7-21.8-56.6-20.8-43.8-1.4-83.9 36.7-84.6 80.2-2.8 35.6 20.5 70.9 53.9 83 33 12 75.4 3.8 96.5-25.5 13.5-18.9 16.2-42.9 16.2-65z" /></svg>
  );
}

IconGPlus.propTypes = iconPropTypes;
IconGPlus.defaultProps = iconDefaultProps;
